module.exports = __webpack_public_path__ + "img/KE-Logo.3623b645.png";